<template>
    <el-dialog
        :visible="visible"
        :modal-append-to-body="false"
        :class="['receipt-upload-input-pdf-dialog', 'ah-detail-dialog']"
        top="6vh"
        append-to-body
        :before-close="onClose"
        :lock-scroll="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        @open="onOpen"
    >
        <template slot="title">
            <div>PDF 檔案上傳</div>
        </template>
        <div class="detail-row">
            <div class="detail-block">
                <center>
                    <ahFileIcon ext="pdf" />
                    <center>上傳中</center>
                </center>
                <center style="margin-top: 20px">
                    <el-button @click="onClose">取消</el-button>
                </center>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import ahFileIcon from '@/components/ui/ahFileIcon.vue';
import axios from 'axios';

export default {
    components: { ahFileIcon },
    props: {
        visible: Boolean,
        file: {
            type: File,
            default: null,
        },
        noUpload: Boolean,
        fileInfo: Boolean,
    },
    methods: {
        onOpen() {
            this.onUpload();
        },
        onClose() {
            this.$emit('close');
        },
        async onUpload() {
            const formData = new FormData();
            formData.append('uploadType', 1);
            formData.append('file', this.file);

            try {
                const resp = this.noUpload ? { data: { url: 'pdfName.pdf' } } : await this.uploadPdf(formData);
                this.$emit('change', {
                    filE_ATT: resp.data.url,
                    formData: this.noUpload ? formData : null,
                    fileInfo: this.fileInfo ? this.file : null,
                });
                this.$nextTick(() => this.onClose());
            } catch {
                this.$message({
                    showClose: true,
                    message: '上傳失敗，請重新上傳。',
                    type: 'error',
                });
            }
        },
        async uploadPdf(formData) {
            return axios.post(`${process.env.VUE_APP_API_PATH}Tool/UploadPdf`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
            });
        },
    },
};
</script>

<style lang="scss" scoped></style>
